// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrap-html[data-v-4e0bfb06] {\n    overflow-wrap: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
